const experiences = [
  {
    title: "Robotics DevOps Engineer",
    company: "Molg Inc",
    link: "https://www.molg.ai",
    location: "Sterling, VA",
    period: "May 2025 - Present",
    descriptions: [
      "Designed and maintained CI/CD pipelines using GitHub Actions, enabling automated build, test, and deployment processes across multiple environments.",
      "Managed and optimized a highly available Kubernetes cluster on Harvester, ensuring robust container orchestration, scalability, and zero-downtime deployments.",
      "Optimized cluster performance with Prometheus, Grafana, and custom alerts.",
      "Streamlined robotics services deployment across development and production environments."
    ]
  },
  {
    title: "Robotics Systems Engineer",
    company: "Alten Technologies USA | Amazon Robotics",
    link: "https://www.altenusa.com",
    location: "North Reading, MA",
    period: "Oct 2024 - Jan 2025",
    descriptions: [
      "Implemented and maintained Sparrow, Amazon's TCON (Tote Consolidation) system, ensuring seamless integration and optimal performance of robotic sorting and fulfillment processes.",
      "Utilized Sparrow's TCON capabilities to efficiently consolidate and manage inventory totes, streamlining order fulfillment and reducing errors."
    ]
  },
  {
    title: "Robotics Systems Engineer",
    company: "Dexterity Inc",
    link: "https://www.dexterity.ai/",
    location: "Redwood City, CA (Remote)",
    period: "Sep 2022 - Oct 2024",
    descriptions: [
      "Implemented infrastructure as code (IaC) using Ansible and Terraform, enabling consistent and repeatable deployments.",
      "Deployed robotic systems using Kubernetes and ArgoCD, enhancing scalability and optimizing system performance.",
      "Developed Python and bash scripts to streamline and automate repetitive tasks, slashing time spent on routine deployment activities by 60% and optimizing operational workflows.",
      "Utilized version control systems (e.g., Git) to manage codebase and track changes.",
      "Participated in troubleshooting and debugging efforts to address production issues and ensure system reliability.",
      "Resolved and troubleshot complex technical issues across diverse technologies, including Linux environments and networking protocols (TCP/IP, DNS, Wireshark, SSL), ensuring seamless system performance and reliability.",
      "Used Wireshark to monitor and troubleshoot network traffic, optimizing network performance in robotic systems.",
      "Implemented a centralized monitoring and alerting system with Checkmk, decreasing incident response times by 45% and significantly boosting system availability and user satisfaction.",
      "Deployed and provisioned networking and robotics systems at customer sites, accompanied by thorough documentation.",
      "Collaborated with stakeholders to create processes and documentation for successful field deployments of network and robotics systems, including build plans, commissioning plans, verification reports, bug reports, and retrospectives.",
      "Interfaced with customers like BBU, UPS, VFC, GXO to ensure integration between WMS and deployed robotics systems."
    ]
  },
  {
    title: "Associate Project Engineer",
    company: "Dexterity Inc",
    link: "https://www.dexterity.ai/",
    location: "Redwood City, CA / Alburtis, PA",
    period: "Sep 2021 - Sep 2022",
    descriptions: [
      "Cooperated with a team of 25+ engineers and technicians to manage deploying a robotic system containing of 17 robots, a conveyor system, safety system and a network system to one of the biggest distribution centers for Bimbo Bakeries USA.",
      "Collaborated with the lead project manager to identify and prioritize the risks; Managed the project backlog and ensure 100% completion and meet customer expectations.",
      "Served as the project manager and prepared Gantt charts and project roadmap to manage resources and increased the efficiency of the deployment by 20% with respect to previous projects.",
      "Played an integral role in commissioning and bringing up the RS020N Kawasaki robots on site. Including but not limited to, setting up the Cubic-S using CS-Configurator software, Azure Kinect vision system calibration and, layout calibration.",
      "Designed and configured a network system containing of servers, gateway and, switches Reduced the hardware cost by 33%.",
      "Integrated and calibrated advanced sensor systems, including Azure Kinect and safety systems with k4aviewr firmware tool and Keyence GC-Configurator, reducing system system integration time by 13%."
    ]
  },
  {
    title: "Product Operations Engineer",
    company: "Dexterity Inc",
    link: "https://www.dexterity.ai/",
    location: "Redwood City, CA",
    period: "May 2021 - Sep 2021",
    descriptions: [
      "Utilized SolidWorks to design and develop detailed mechanical components.",
      "Created angle schematics and orthographic views of mechanical design components for enhanced visualization.",
      "Coordinated with engineers to evaluate design options and ensure optimal functionality.",
      "Calculated required materials and costs for product development, considering factors like quality and cost-effectiveness.",
      "Prepared comprehensive BOMs (Bill of Materials) for safety controller units, listing all raw materials, components, and assemblies required for production.",
      "Remotely helping engineering team onsite with manually intervening and assisting robots with teach pendant in the event of unforeseen events / errors when robot breaches safety parameters and enters protective stop mode."
    ]
  },
  {
    title: "Graduate Research/Teaching Assistant",
    company: "Autonomous and Intelligent Robotics (AIR) Lab",
    link: "https://wordpress.lehigh.edu/robotics/",
    location: "Bethlehem, PA",
    period: "Aug 2017 - May 2021",
    descriptions: [
      "Developed path planning algorithms for swarm of robots using object oriented design with C++ and OpenCV and graph search based algorithms.",
      "Designed and developed algorithms towards \"Simultaneous Localization and Mapping (SLAM)\" problem for a swarm of decentralized robots with limited resources and directional sensors.",
      "Implemented Kalman filtering, localization, path planning, controls and, etc.",
      "Managed a drone lab project at AIRLAB, overseeing the installation of critical hardware components such as servers, network infrastructure, drones, and lidar sensors.",
      "Commissioned the entire hardware system, ensuring proper functioning and resolving any technical issues.",
      "Developed a simple Python application to execute basic maneuvers on the drones.",
      "Conducted motion planning simulations on Coppeliasim Software as part of the project."
    ]
  }
];

export default experiences;
